import { render, staticRenderFns } from "./headerMenuChildren.vue?vue&type=template&id=5b7ecc6e&"
import script from "./headerMenuChildren.vue?vue&type=script&lang=js&"
export * from "./headerMenuChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/default/aside/headerMenuChildren.vue"
export default component.exports